module.exports = __webpack_public_path__ + "static/media/stripelogo.33022fdd.png";